const buildUrl = (url, ordinal, parentCategory?) => {
  const otherSort = parentCategory && parentCategory.url === 'other-sneakers';
  return ordinal === 3 && !otherSort ? `${parentCategory.url}/${url}` : url;
};

export default buildUrl;
